import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

function SubHeader({ menuOpen, setMenuOpen }) {
	const { t } = useTranslation();

	const onMouseEnter = useCallback((e) => {
		e.currentTarget.classList.add('sub-header__nav-link--hovered');
	}, []);

	const onMouseLeave = useCallback((e) => {
		e.currentTarget.classList.remove('sub-header__nav-link--hovered');
	}, []);

	const navLinks = [
		{
			label: t('mainScreen.header.products'),
			href: 'https://developer.mercedes-benz.com/products?u=Retailer',
		},
		{
			label: t('mainScreen.header.contact'),
			href: 'https://developer.mercedes-benz.com/help/contact',
		},
		{
			label: t('mainScreen.header.support'),
			href: 'https://developer.mercedes-benz.com/help/support',
		},
	];

	return (
		<div className="sub-header">
			<div className="sub-header__inner">
				<nav className="sub-header__nav sub-header__nav--desktop" aria-label="Primary navigation">
					{navLinks.map(({ label, href }) => (
						<a
							key={href}
							className="sub-header__nav-link"
							data-title={label}
							href={href}
							rel="noopener noreferrer"
							target="_blank"
							onMouseEnter={onMouseEnter}
							onMouseLeave={onMouseLeave}
						>
							{label}
						</a>
					))}
				</nav>

				<a
					className="sub-header__company-name"
					href="https://connectivity.mercedes-benz.com/"
					rel="noopener noreferrer"
					target="_blank"
					data-testid="sub-header-company-name"
				>
					{t('mainScreen.header.companyName')}
				</a>
			</div>

			{menuOpen && (
				<nav className="sub-header__mobile-nav" aria-label="Mobile navigation">
					{navLinks.map(({ label, href }) => (
						<a
							key={href}
							className="sub-header__mobile-nav-link"
							href={href}
							rel="noopener noreferrer"
							target="_blank"
							onClick={() => setMenuOpen(false)}
						>
							{label}
						</a>
					))}
				</nav>
			)}
		</div>
	);
}

export default SubHeader;